<template>
    <section>
      <header-com v-if='!goodsCode'/>
      <div class="container f28" :class='{padding0:goodsCode}'>
        <h1 class="f56">效果方案</h1>
        <order-module-title title="基本信息"/>
        <div class="basic info">
          <div>
            <span class="grey6">分类：</span>
            <span>{{effect.category}}</span>
          </div>
          <div>
            <span class="grey6">品牌：</span>
            <span>{{effect.brand}}</span>
          </div>
          <div>
            <span class="grey6">款式：</span>
            <span>{{effect.style==1?'男款':'女款'}}</span>
          </div>
          <div>
            <span class="grey6">颜色：</span>
            <span>{{effect.color}}</span>
          </div>
        </div>
        <div class="block"></div>
        <div class="mt30">
          <order-module-title title="服务项目"/>
        </div>
        <div class="service info">
          <div v-for='(item,index) in effect.goodsCuringServiceBoList' :key='index'>{{item.curingServiceName}} x {{item.quantity}}</div>
        </div>
        <div class="block" v-if='effect.detailPicList.length != 0'></div>
        <div class="mt30" v-if='effect.detailPicList.length != 0'>
          <order-module-title title="细节展示"/>
        </div>
        <div class="detail info" v-if='effect.detailPicList.length != 0'>
          <div v-for='(item,index) in effect.detailPicList'>
            <img src="" alt="" v-lazy="formatImgUrl(item,300,240,true)" @click='previewDetail(index,effect.detailPicList,"细节展示")'/>
          </div>
        </div>
        <div class="block"></div>
        <div class="mt30">
          <order-module-title title="效果对比图"/>
        </div>

        <div class="photos info" v-for='(item,index) in effect.effectCompareBoList'>
          <div>
            <span class="grey6">服务名称：</span>
            <span>{{item.curingServiceName}}</span>
          </div>
          <div class='three' :class='{all:imgTags[index]}'>
            
            <div class="photos-wrap" v-for='(data,dataIndex) in item.goodsEffectBoList'>
              <div>
                <img src="" alt="" v-lazy="formatImgUrl(data.beforePic,500,440,true)" @click='preview(data,0)'/>
                <div>修复前</div>
              </div>
              <div>
                <img src="" alt="" v-lazy="formatImgUrl(data.afterPic,500,440,true)" @click='preview(data,1)'/>
                <div>修复后</div>
              </div>
            </div>
          </div>
          <button class="down f26 grey6" v-if='item.goodsEffectBoList.length > 3 && !imgTags[index]' @click='clickAction(index)'>展示完整信息 <i></i></button>
          <button class="up f26 grey6" v-if='item.goodsEffectBoList.length > 3 && imgTags[index]' @click='clickAction(index)'>收起 <i></i></button>
        </div>

        <!-- 必看图片 -->
        <div class="photos info" v-if='effect.mustPhotos.length>0'>
          <div>
            <span>其它图片</span>
          </div>
          <div class='three' :class='{all:mustImgTags}'>
            
            <div class="photos-wrap" v-for='(data,dataIndex) in effect.mustPhotos' :key="dataIndex">
              <div>
                <img src="" alt="" v-lazy="formatImgUrl(data.beforePic,500,440,true)" @click='preview(data,0)'/>
                <div>修复前</div>
              </div>
              <div>
                <img src="" alt="" v-lazy="formatImgUrl(data.afterPic,500,440,true)" @click='preview(data,1)'/>
                <div>修复后</div>
              </div>
            </div>
          </div>
          <button class="down f26 grey6" v-if='effect.mustPhotos.length > 3 && !mustImgTags' @click='clickAction2'>展示完整信息 <i></i></button>
          <button class="up f26 grey6" v-if='effect.mustPhotos.length > 3 && mustImgTags' @click='clickAction2'>收起 <i></i></button>
        </div>
        <!-- 必看图片 -->
      </div>
      <previewer ref="previewer"></previewer>
      <img src='/images/public/uppage.png' class='pageUp' @click='page(0)' v-if='showIndex != 0 && !goodsCode'>
      <img src='/images/public/downpage.png'  class='pageDown' @click='page(1)' v-if='showIndex != idIndex.length-1 && !goodsCode'>
    </section>
</template>

<script>
  import orderApi from '@/axios/order'
  export default {
    name: 'index',
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    data () {
      return {
          id : '',
          goodsCode : '',
          effect : {
            effectCompareBoList : [],
            detailPicList : []
          },
          imgTags : [],
          mustImgTags: false,
          eId : '',
          idIndex : [],
          showIndex : 0
      }
    },
    created () {
      this.id = this.$route.query.id + '';
      this.goodsCode = this.$route.query.goodsCode;
      if(this.goodsCode){
        this.getEffectsEncrypt(this.goodsCode);
        return;
      }

      this.idIndex = this.id.split(',');
      this.setIndexAction();

      
    },
    mounted () {
      
    },
    methods: {
      setIndexAction(){
        this.getEffects(this.idIndex[this.showIndex]);
      },
      page(index){
        if(index){
          this.showIndex++; 
        }else{
          this.showIndex--; 
        }

        this.setIndexAction();
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      previewDetail(index,list,title){
        this.$refs.previewer.show(index, list,title)
      },
      preview(item,index){
        
        let imgList = [];
        imgList.push(item.beforePic);
        imgList.push(item.afterPic);
        this.$refs.previewer.show(index,imgList,['修复前','修复后'])
      },
      clickAction(index){
        this.$set(this.imgTags,index,!this.imgTags[index])
      },
      clickAction2(){
        this.mustImgTags = !this.mustImgTags
      },
      getEffectsEncrypt(eid){
        orderApi.getEffectsEid(eid).then((res)=>{

          res.effectCompareBoList.forEach((element)=>{
            this.imgTags.push(false);
          })
          this.effect = res;
        })
      },
      getEffects(id){
        orderApi.getEffects(id).then((res)=>{

          res.effectCompareBoList.forEach((element)=>{
            this.imgTags.push(false);
          })
          this.effect = res;
          //如果是客户自己查看效果方案触发行为
          let params = {
            behaviorType : 21,
            goodsCodeList : res.goodsCode
          }
          orderApi.behavior(params).then((res)=>{
            
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .pageUp,.pageDown{
    width: 100px;
    position: fixed;
    top:50%;
    right: 20px;
  }
  .pageUp{
    margin-top:-50px; 
  }
  .pageDown{
    margin-top:50px; 
  }
  .padding0{
    padding-top:20px!important;
  }
  .all{
    height: auto;
    max-height: 1000000px!important;
    overflow: visible!important;
  }
  .three{
    max-height: 1015px;
    overflow: hidden;
    margin-top: 20px;
  }
  .container{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 116px;
    h1{
      width: 690px;
      font-weight: 500;
      line-height: 80px;
      margin-bottom: 50px;
    }
    .info{
      padding: 30px 30px 30px 50px;
      
    }
    .basic{
      display: flex;
      flex-wrap: wrap;
      padding-left: 0px!important;
      padding-right: 0px!important;
      margin-left: 100px;
      width: 100%;
      div{
        width: 50%;
        line-height: 40px;
        margin-bottom: 20px;
        &:last-child, &:nth-last-child(2){
          margin-bottom: 0
        }
      }
    }
    .service{
      flex-direction: column;
      width: 650px;
      div{
        color: #FF6710;
        line-height: 40px;
        margin-bottom: 20px;
        &:last-child{
          margin: 0;
        }
      }
    }
    .detail{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-top:0;
      &>div{
        width: 286px;
        height: 228px;
        margin-top:30px;
        margin-right: 20PX;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .photos{
      width: 650px;
      &>.three{
        margin-bottom: 20px;
        .photos-wrap{
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 316px;
          margin-top:10px;
          margin-bottom: 20px;
          &>div{
            width: 316px;
            height: 316px;
            border-radius: 6px;
            border: 1px solid rgba(222,222,222,1);
            overflow: hidden;
            img{
              width: 316px;
              height: 236px;
              object-fit: cover;
            }
            div{
              text-align: center;
              line-height: 80px;
            }
          }
        }
      }
      .down{
        padding: 0 20px;
        height: 56px;
        border-radius: 28px;
        border: 2px solid rgba(214,214,214,1);
        margin: 10px auto 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        i{
          width: 22px;
          height: 14px;
          background: url("/images/public/arrow-down.png") no-repeat center;
          background-size: cover;
          display: block;
          margin-left: 4px;
        }
      }
      .up{
        padding: 0 20px;
        height: 56px;
        border-radius: 28px;
        border: 2px solid rgba(214,214,214,1);
        margin: 10px auto 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        i{
          width: 22px;
          height: 14px;
          background: url("/images/public/arrow-up.png") no-repeat center;
          background-size: cover;
          display: block;
          margin-left: 4px;
        }
      }
    }
  }
</style>
